<div class="app-svg-icon">
    <span class="app-svg-icon__item"
          [innerHTML]="svgIcon"
          [style.color]="fill"
          [style.height]="height"
          [style.width]="width"
          [style.display]="flex ? 'flex' : 'inline-block'">
    </span>
  </div>